module.exports = __webpack_public_path__ + "static/media/Sliggoo_gaussian2.328a055f.png";